import { render, staticRenderFns } from "./PostAndEditShortArticleModule.vue?vue&type=template&id=f80c3f06&"
import script from "./PostAndEditShortArticleModule.vue?vue&type=script&lang=js&"
export * from "./PostAndEditShortArticleModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports